export interface DynamicField {
  id: string;
  name: string;
  type: FieldType;
  required?: boolean;
  is_fixed?: boolean;
  options?: string[]; // Para combo box
  defaultValue?: any;
  order?: number;
  service_id?: number; // ID del servicio (para mapeo con backend)
}

export interface ServiceFieldConfiguration {
  service_id: number;
  fields: DynamicField[];
}

export enum FieldType {
  TEXT = 'text',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  COMBO = 'combo',
  DATE = 'date',
  EMAIL = 'email',
  TEXTAREA = 'textarea'
}

export const FIELD_TYPE_OPTIONS = [
  { value: FieldType.TEXT, label: 'Texto' },
  { value: FieldType.NUMBER, label: 'Número' },
  { value: FieldType.BOOLEAN, label: 'Sí/No' },
  { value: FieldType.COMBO, label: 'Lista desplegable' },
  { value: FieldType.DATE, label: 'Fecha' },
  { value: FieldType.EMAIL, label: 'Email' },
  { value: FieldType.TEXTAREA, label: 'Área de texto' }
];